import React from 'react';
import { createRoot } from "react-dom/client";
import { store } from "./store/store";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import Login from './pages/login';

// import 'antd/dist/antd.css';
import 'antd/dist/antd.min.css'

import './styles/main.css';
// import './styles/index.scss';

import AuthContext from './core/authentication/AuthContext';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/core/translations/i18n'
import Index from './pages';
import DashboardLayout from '@/layouts/Dashboard/DashboardLayout';

// import AccountPage from '@/pages/account';
import InvoicesPage from '@/pages/account/invoices';
import AccountLayout from '@/layouts/AccountLayout/AccountLayout';
import ProfilePage from '@/pages/account/profile';
import ArticleHistory from './pages/account/articleHistory';
import AccountSettings from './pages/account/settings';
import UnpaidInvoices from './pages/account/unpaidInvoices';
import PaidedInvoices from './pages/account/paidedInvoices';
import PackingSlip from './pages/account/packingSlip';
import Catalog from './pages/catalog';
import Bootstrap from './core/bootstrap/Bootstrap';
import Logout from './pages/logout';
import History from './pages/history';
import TecdocLayout from './layouts/TecdocLayout/TecdocLayout';
import TecdocMainCategories from './pages/tecdoc/mainCategories';
import TecdocSubCategories from './pages/tecdoc/subcategories';
import AddTecdocCategory from './pages/tecdoc/addTecdocCategory';
import DispatchBrandCategory from './components/tecdocSettings/TecdocMenuCreate/DispatchBrandCategory';
import axios from 'axios';
import UniversalParts from './pages/universalParts';
import VehicleSearch from './pages/vehicleSearch';
import ManagementLayout from './layouts/ManagementLayout/ManagementLayout';
import ManagementUsers from './pages/management/ManagementUsers';
import ManagementLanguages from './pages/management/ManagementLanguages';
import ManagementWorkingHours from './pages/management/ManagementWorkingHours';
import ManagementSettings from './pages/management/ManagementSettings';
import ManagementAnnouncemenets from './pages/management/ManagementAnnouncemenets';
import ManagementCarousel from './pages/management/ManagementCarousel';
import ManagementTheme from './pages/management/ManagementTheme';
import ManagementCatalog from './pages/management/catalog/ManagementCatalog';
import ManagementCatalogSubCategories from './pages/management/catalog/ManagementCatalogSubCategories';
import ManagementCatalogGenericArticles from './pages/management/catalog/ManagementCatalogGenericArticles';
import ManagementCatalogAssignBrands from './pages/management/catalog/ManagementCatalogAssignBrands';
import ResetPassword from './pages/resetPassword';

const DEVELOPMENT = false



const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthContext>
        <DashboardLayout>
          <Index />
        </DashboardLayout>
      </AuthContext>
    ),
  },
  {
    path: "login",
    element: <Login />
  },
  {
    path: "reset-password",
    element: <ResetPassword />
  },
  {
    path: "logout",
    element: <Logout />
  },

  {
    path: "catalog",
    element: <AuthContext>
      <DashboardLayout>
        <Catalog />
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "vehicle-search",
    element: <AuthContext>
      <DashboardLayout>
        <VehicleSearch />
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "account/invoices",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <InvoicesPage />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "account/profile",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <ProfilePage />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "account/article-history",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <ArticleHistory />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "history",
    element: <AuthContext>
      <DashboardLayout>
        <History />
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "account/settings",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <AccountSettings />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "account/unpaid-invoices",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <UnpaidInvoices />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/users",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementUsers />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/languages",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementLanguages />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/carousel",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementCarousel />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/working-hours",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementWorkingHours />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/theme",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementTheme />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/settings",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementSettings />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/catalog-tecdoc",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementCatalog />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/catalog-tecdoc/:categoryId",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementCatalogSubCategories />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/catalog-tecdoc/:categoryId/subcategories/:subcategoryId",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementCatalogGenericArticles />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/catalog-tecdoc/brands/subcategory/:subcategoryId/:genericArticleId",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementCatalogAssignBrands />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "management/announcemenets",
    element: <AuthContext>
      <DashboardLayout>
        <ManagementLayout>
          <ManagementAnnouncemenets />
        </ManagementLayout>


      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "account/paided-invoices",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <PaidedInvoices />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
  {
    path: "universal-parts",
    element: <AuthContext>
      <DashboardLayout>
        <UniversalParts />
      </DashboardLayout>
    </AuthContext>
  },
  // {
  //   path: "universal-parts-ps",
  //   element: <AuthContext>
  //     <DashboardLayout>
  //       <UniversalParts />
  //     </DashboardLayout>
  //   </AuthContext>
  // },
  {
    path: "account/packing-slips",
    element: <AuthContext>
      <DashboardLayout>
        <AccountLayout>
          <PackingSlip />
        </AccountLayout>
      </DashboardLayout>
    </AuthContext>
  },
 
]);

try {
  let PS_TOKEN = null
  if (process.env.NODE_ENV === 'development') {

  } else {
    PS_TOKEN = document.getElementById('PS_TOKEN').value
  }

  window.REST_API_TOKEN = PS_TOKEN

  if (DEVELOPMENT) {
    const translations = document.createElement("div"); // display none
    translations.style.display = "none";
    translations.id = "translationsdata";
    const sitesettings = document.createElement('div');
    sitesettings.style.display = "none";
    sitesettings.id = "sitesettings";
    const languagelist = document.createElement('div');
    languagelist.style.display = "none";
    languagelist.id = "languagelist";

    axios.get('http://localhost:3000/developer/testb2b.parts-soft.eu').then((res) => {
      sitesettings.innerHTML = JSON.stringify(res.data.siteSettings)
      languagelist.innerHTML = JSON.stringify(res.data.languagelist)
      translations.innerHTML = JSON.stringify(res.data.translations)
      window.REST_API_TOKEN = res.data.psToken
      document.body.appendChild(sitesettings);
      document.body.appendChild(languagelist);
      document.body.appendChild(translations);

      let pwaDOM = createRoot(document.getElementById("root")).render(
        <I18nextProvider i18n={i18n}>
          <Provider store={store}>
            <Bootstrap><RouterProvider router={router} /></Bootstrap>
          </Provider>
        </I18nextProvider>
      );
    })

    //append body
  } else {
    let pwaDOM = createRoot(document.getElementById("root")).render(
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <Bootstrap><RouterProvider router={router} /></Bootstrap>
        </Provider>
      </I18nextProvider>
    );
  }
} catch (e) {
  console.log(e);
}



